import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getHelpInfo } from "./common/service";

export function customerServiceLoader() {
  return defer({
    coreData: resolveLoaderResult(getHelpInfo()),
  });
}
